import React, {Suspense, useEffect} from 'react';
// DO NOT DELETE
import i18n from "../i18n";
import { useTranslation } from "react-i18next";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    useLocation
} from "react-router-dom";
import Main from "../pages"
import Patient from "../pages/patient"
import Assay from "../pages/assay";
import Biobank from "../pages/biobank";
import Documents from "../pages/documents";
import Order from "../pages/order";
import Header from "../components/header";
import Footer from "../components/footer";
import '../App.css'

/**
 * Wraps the Routes in a keyed container so each navigation triggers a
 * remount and the CSS keyframe `routeIn` runs. Also smooth-scrolls the
 * page back to the top so the user doesn't land mid-page after a long
 * scroll on the previous route.
 */
function AnimatedRoutes() {
    const location = useLocation();

    useEffect(() => {
        // Defer to the next frame so the new content has mounted before
        // we trigger the scroll — otherwise the smooth-scroll runs against
        // the OLD page height and overshoots.
        const id = window.requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        return () => window.cancelAnimationFrame(id);
    }, [location.pathname]);

    return (
        <div className="route-content" key={location.pathname}>
            <Routes>
                <Route path="/" element={<Main/>}/>
                <Route path="patients" element={<Patient/>}/>
                <Route path="assays" element={<Assay/>}/>
                <Route path="biobanks" element={<Biobank/>}/>
                <Route path="documents" element={<Documents/>}/>
                <Route path="order" element={<Order/>}/>
            </Routes>
        </div>
    );
}

const App = () => {
    // Subscribe to i18n at the App level so a language change re-renders
    // every route child. The class-based containers read `i18n.t(...)`
    // directly at render time but don't subscribe themselves; without
    // this hook, swapping language only updated the header.
    const { i18n: i18nInstance } = useTranslation();
    void i18nInstance.language;

    // Cursor-tracked specular highlight on glass buttons.
    // Sets --mx/--my CSS variables on the hovered button so the
    // ::after radial gradient (defined in index.css) lights up under
    // the pointer — Apple Liquid Glass behavior. Single delegated
    // listener on window keeps this cheap (one handler, no per-component
    // state). Skip on coarse pointers (touch) where the effect is
    // invisible anyway.
    useEffect(() => {
        if (window.matchMedia('(pointer: coarse)').matches) return;
        const SELECTOR = '.btn, .glass-btn, .glass-btn--secondary, .glass-btn--chip, .filter-apply-btn, .order-apply-btn, .document-download-btn, .notification-button, .mail-request-submit-btn, .filter-research-btn-full, .filter-request-btn, .mail-request-cancel-btn, .document-view-btn, .filter-select-all-btn, .order-select-all-btn';
        const onMove = (e) => {
            const el = e.target.closest(SELECTOR);
            if (!el) return;
            const r = el.getBoundingClientRect();
            el.style.setProperty('--mx', `${e.clientX - r.left}px`);
            el.style.setProperty('--my', `${e.clientY - r.top}px`);
        };
        window.addEventListener('pointermove', onMove, { passive: true });
        return () => window.removeEventListener('pointermove', onMove);
    }, []);

    return (
        <Router>
            <div className="App container my-5">
                <Header/>
                <Suspense fallback={null}>
                    <AnimatedRoutes/>
                </Suspense>

                <Footer/>

            </div>
        </Router>
    );
}

export default App;
